import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import VimdtButton from './VimdtButton';

/**
 * Expand/collapse-all toggle shared by the image, equipment and specification lists.
 */
function CollapseAllToggle({ panelHandler, panels, availablePanels }) {
	const { t } = useTranslation();
	const [collapsed, setCollapsed] = useState(false);

	useEffect(() => {
		if (panels.length === 0) {
			setCollapsed(true);
		} else if (panels.length === availablePanels.length) {
			setCollapsed(false);
		}
	}, [panels, availablePanels]);

	return (
		<VimdtButton
			filledIn={false}
			label={collapsed ? t('vimdt.components.showAllButton') : t('vimdt.components.collapseAll')}
			onClick={() => panelHandler(collapsed ? 0 : 1)}
		/>
	);
}

export default CollapseAllToggle;
